import React, { useEffect, useState } from 'react'

import { LogoURLInterface } from '../../../Interfaces/CompanyInterface'
import LoadingEllipsis from '../LoadingEllipsis'
import './ImageInput.scss'

interface PropsType {
  tradeNameId?: string
  label?: string
  automation?: string
  logoDataUrl: string
  allowDeletion?: boolean
  loading: boolean
  uploadImage: (image: Blob, fileName: string) => Promise<LogoURLInterface>
  onDelete?: () => void
  onChange?: (logoId: string, content: string) => void
  openLogoModal: (
    logo: string,
    fileName: string,
    changeLogoField: (logoId: string, content: string) => void,
    uploadLogo: (image: Blob, fileName: string) => Promise<LogoURLInterface>,
  ) => void
}

const ImageInput: React.FC<PropsType> = (props: PropsType) => {
  const { uploadImage, openLogoModal, onChange, onDelete, label, automation, loading, logoDataUrl, allowDeletion } =
    props
  let inputRef: HTMLInputElement
  const baseClasses = ['Controlled', 'Input', 'FilePreview']
  const [logo, setLogo] = useState(logoDataUrl)

  useEffect(() => {
    setLogo(logoDataUrl)
  }, [logoDataUrl])

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    e.preventDefault()
    const logoFile = e.target.files[0]
    if (logoFile) {
      const reader = new FileReader()
      reader.readAsDataURL(logoFile as Blob)
      reader.onload = () => {
        const logo = reader.result as string
        const fileName = logoFile.name
        openLogoModal(logo, fileName, onChange, uploadImage)
      }
      reader.onerror = (error) => {
        console.error('Failed to open logo modal caused by error: ', error)
      }
      const input = document.getElementById('logoInput') as HTMLInputElement
      input.value = ''
    }
  }

  const Label: React.FC<unknown> = (): JSX.Element => {
    if (label) {
      return (
        <span className="Label" data-automation={automation + '-label'}>
          {label}
        </span>
      )
    }
    return null
  }

  return (
    <div className={baseClasses.join(' ')}>
      <Label />
      <div className={'imageInputContainer'}>
        <input
          id="logoInput"
          ref={(input) => {
            inputRef = input
          }}
          type="file"
          accept=".jpeg,.JPEG,.jpg,.JPG,.png,.PNG,.gif,.GIF"
          className={'fileInput'}
          data-automation={automation}
          onChange={(e) => handleOnChange(e)}
        />
        {loading && <LoadingEllipsis />}
        <a
          className="image"
          onClick={() => {
            inputRef.click()
          }}
          style={{ backgroundImage: `url(${logo})` }}
        ></a>
        {allowDeletion && <div className="Clear" onClick={() => onDelete()}></div>}
      </div>
    </div>
  )
}

export default ImageInput
